export default "__VITE_ASSET__Ce_GdPJ5__"